import { brand } from '../../lib/brand';
import { useTheme } from '../../lib/useTheme';

/**
 * Wordmark de arte final: contornos SVG para que la geometría aprobada no dependa
 * de la carga de una fuente. En oscuro elige la variante con tinta clara y ámbar
 * elevado; el nombre de producto en prosa sigue saliendo de `brand.name`.
 */
type BrandWordmarkProps = {
  /** Controla el tamaño vía font-size/leading (p. ej. `text-2xl`). */
  className?: string;
};

export default function BrandWordmark({ className }: BrandWordmarkProps) {
  const { isDark } = useTheme();

  return (
    <img
      src={isDark ? brand.assets.wordmarkInverse : brand.assets.wordmark}
      alt={brand.wordmarkText}
      className={['block h-[1.24em] w-auto shrink-0', className]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
